import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Stepper from 'bs-stepper';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AuthService, DialogModalService, NotificationService, ValidatorsService } from 'src/app/services';
import { ConfirmActionComponent } from '../../../confirm/confirm-action/confirm-action.component';
import { ForgotPasswordValidator } from './forgot-password.validator';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  private stepper: Stepper;
  confirmation_email: string;
  progressRef: NgProgressRef;
  errorMessages: any;
  field: string;
  nextStepCode: boolean;
  nextStepPass: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    public ngProgress: NgProgress,
    private dialogModal: DialogModalService,
    private authService: AuthService,
    private validatorService: ValidatorsService,
    public activeModal: NgbActiveModal,
    private validator: ForgotPasswordValidator,
    private notification: NotificationService,
  ) { }

  formForgPass: UntypedFormGroup = this.fb.group({
    confirmation_email: [null, this.validator.confirmation_email],
    confirmation_code: [null, this.validator.confirmation_code],
    password: [null, this.validator.password],
    confirm_password: [null, this.validator.confirm_password],
  },
   {
    validator: this.validatorService.mustMatch('password', 'confirm_password')
  });

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.initStepper();

    this.authService.listenerIsEmailCheck().subscribe(value => {

      if (value) {

        this.nextStep();
        this.nextStepPass = true;
        
      }
    });

    this.subscriptions.add(

      this.formForgPass.get('confirmation_email').valueChanges.subscribe(val => {

        this.confirmation_email = val;
      })
    );
    
  }

  checkMail() {

    let params = {
      email: this.formForgPass.get('confirmation_email').value,
      action: 'forgot_password'
    }

    this.nextStepCode = true;

    console.log(params);
    

    this.authService.checkEmail(params, this.progressRef);

  }

  /**
  * 
  */
   checkRegistration() {

      let params = {
        email: this.formForgPass.get('confirmation_email').value,
        code: this.formForgPass.get('confirmation_code').value
      }

      
      //проверка на ответ
      
      console.log(params);

      this.authService.checkRegistrationCode(params);
  
    }

  /**
  * 
  */
   resetPass() {

      let params = {
        email: this.formForgPass.get('confirmation_email').value,
        email_code: this.formForgPass.get('confirmation_code').value,
        password: this.formForgPass.get('password').value,
        confirm_password: this.formForgPass.get('confirm_password').value
      }
      
      console.log(params);
      
      this.notification.show('success', 'Ваш пароль успешно изменен!');

      return this.authService.resetPass(params, this.progressRef)

    }


  /**
   * 
   */
  initStepper(): void {

    this.stepper = new Stepper(document.querySelector('#stepper2'), {
      linear: false,
      animation: true
    })
  }


  /**
   * 
   */
  nextStep(): void {

    this.stepper.next();
  }
  

  /**
   * 
   */
  prevStep(): void {

    this.stepper.previous();
  }


    /**
     * 
     * @param field 
     * @param type 
     */
    validation(field: string, type: string): boolean {

      return this.validatorService.validation(this.formForgPass.get(field), type);
    }
  
    /**
     * 
     * @param field 
     */
    checkingFieldStatus(field: string): string {
  
      return this.validatorService.checkingFieldStatus(this.formForgPass.get(field));
    }


  // /**
  // * 
  // *
  // */
  // onConfirm() {

  //   let message = 'Вы действительно хотите закрыть данное окно?';

  //   this.dialogModal.open(message, ConfirmActionComponent, "lg").then(
  //     (result) => {

  //       if (result) {

  //         this.activeModal.dismiss(false);
  //       }
  //     },
  //     () => { console.log('Rejected!'); }
  //   );

  // }


}
